<app-header></app-header>
<div class="container" ngClass.lt-md="mobile-container">
  <app-progress-bar></app-progress-bar>
  <router-outlet></router-outlet>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="large"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

